export enum ValidationStepType {
	Import, // 0
	SetDefaultDeburring, // 1
	UpdateWeight, // 2
	FeatureRecognition, // 3
	UpdateScDoc, // 4
	Design, // 5
	BendSimulation, // 6
	SetDefaultRollDirection, // 7
	ValidateUnfoldedSize, // 8
	Lasercut, // 9
	UpdateAssembly, // 10
	UpdateThumbnail, // 11
	UpdateBoundingBox, // 12
	Final, // 13
	Close, // 14
	DeleteBodyOfAssembly, // 15
}

export function getValidationStepTypeText(value: ValidationStepType): string {
	switch (value) {
		case ValidationStepType.Import:
			return "Import";
		case ValidationStepType.SetDefaultDeburring:
			return "Entgratart festlegen";
		case ValidationStepType.UpdateWeight:
			return "Gewicht updaten";
		case ValidationStepType.FeatureRecognition:
			return "Featureerkennung";
		case ValidationStepType.UpdateScDoc:
			return "ScDoc updaten";
		case ValidationStepType.Design:
			return "Design";
		case ValidationStepType.BendSimulation:
			return "Biegesimulation";
		case ValidationStepType.SetDefaultRollDirection:
			return "Schliffrichtung festlegen";
		case ValidationStepType.ValidateUnfoldedSize:
			return "Abwicklungsgrösse validieren";
		case ValidationStepType.Lasercut:
			return "Calculate"; // Calculate step runs when lasercutting. Gives more information.
		case ValidationStepType.UpdateAssembly:
			return "Baugruppe updaten";
		case ValidationStepType.UpdateThumbnail:
			return "Thumbnail updaten";
		case ValidationStepType.UpdateBoundingBox:
			return "Bouding Box updaten";
		case ValidationStepType.Final:
			return "Finalisieren";
		case ValidationStepType.Close:
			return "Schliessen";
		case ValidationStepType.DeleteBodyOfAssembly:
			return "Baugruppen-Körper löschen";
		default:
			return "Nicht verfügbar";
	}
}
